export default __webpack_public_path__ + "static/media/alert-success.04e056a5.svg";